import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	backButtonLabel: {
		id: 'servicedesk-insight-object-schema-page.page-content.loaded.page-content.object-view.back-button-label',
		defaultMessage: 'Back to list view',
		description: 'Label for a button takes the user back to the schema list view',
	},
});
